/*
 * Javascripts .trim() method mutates the string it's called on.  This'll create
 * a copy before calling .trim()
 */
export const trim = (str: string) => `${str}`.trim()
